<template>
  <div class="grid-container sm:justify-center">
    <div
      class="flex flex-col justify-center gap-4 w-full pt-6 md:pt-14 sm:col-[4_/_-4] md:col-[5_/_-5] xl:col-[4_/_-4]"
    >
      <div class="md:mx-12">
        <header>
          <h1 class="pb-2 headline-md md:headline-lg">Registrar usuario </h1>
        </header>
        <form @submit.prevent="submitRegistrationForm" class="py-3">
          <TextInput
            id="name"
            v-model="form.name"
            required
            type="text"
            label="Nombres"
            :error="errors.name"
          />
          <TextInput
            id="email"
            v-model="form.email"
            type="email"
            label="Correo electrónico"
            placeholder="hi@example.com"
            required
            :error="errors.email"
          />
          <TextInput
            id="password"
            v-model="form.password"
            type="password"
            label="Contraseña"
            required
            :error="errors.password"
          />
          <TextInput
            id="password_confirmation"
            v-model="form.password_confirmation"
            type="password"
            label="Confirmar contraseña"
            required
            :error="errors.password_confirmation"
          />
          <FormSelect
            id="company_size"
            v-model="form.company_size_id"
            label="Tamaño"
            required
            :error="errors.company_size"
            >
            <option value="" disabled>Seleccionar</option>
            <option v-for="size in company_sizes" :key="size.id" :value="size.id">
                {{ size.name }}
            </option>
            </FormSelect>
            <FormSelect
            id="company_category"
            v-model="form.company_category_id"
            label="Rubro"
            required
            :error="errors.company_category"
            >
            <option value="" disabled>Seleccionar</option>
            <option v-for="category in company_categories" :key="category.id" :value="category.id">
                {{ category.name }}
            </option>
            </FormSelect>
            <TextInput
                id="companyname"
                v-model="form.companyname"
                type="text"
                label="Empresa nueva"
                :error="errors.companyname"
            />
            <FormSelect
            id="company_id"
            v-model="form.company_id"
            label="Compañias existentes"            
            :error="errors.company_id"
            >
            <option value="0">Seleccionar</option>
            <option v-for="company in companies" :key="company.id" :value="company.id">
                {{ company.name }}
            </option>
            </FormSelect>
          <Button type="submit" class="btn-filled block my-4 mx-auto" :isLoading="form.processing">
            Guardar
          </Button>
        </form>
      </div>
    </div>
  </div>
</template>

<script>
import { Link } from '@inertiajs/inertia-vue'
import Layout from '@/Layouts/Layout'
import Button from '@/Components/Button'
import TextInput from '@/Components/FormInputText'
import CheckInput from '@/Components/FormInputCheck'
import FormSelect from '@/Components/FormSelect'

export default {
  name: 'CreateCompanyUser',
  layout: Layout,
  props: {
    errors: { type: Object },
    company_sizes: {type: Array},
    company_categories: { type: Array},
    companies: { type: Array},
  },
  components: {
    Link,
    Button,
    TextInput,
    CheckInput,
    FormSelect,
  },
  data() {
    return {
      btnIsLoading: false,
      form: this.$inertia.form({
        name: '',
        company_size_id: 3,
        company_category_id: 19,
        company_id: 0,
        email: '',
        password: '',
        password_confirmation: '',
        companyname: '',
      }),
    }
  },
  methods: {
    submitRegistrationForm() {
      const swalErrorConfig = {
        title: '¡Lo sentimos! :(\nHa ocurrido un error.',
        text: 'Por favor, revisa los datos e intenta de nuevo',
      }

      this.form
        .transform(data =>
          Object.fromEntries(Object.entries(data).filter(([_, v]) => v != null && v != '')),
        )
        .post(this.$route('company.users.create'), {
          onBefore: () => (this.btnIsLoading = true),
          onFinish: () => (this.btnIsLoading = false),
          onError: errors => {
            console.log(errors)
            this.$swal.fire(swalErrorConfig)
          },
        })
    },
  },
}
</script>
